module.exports = __webpack_public_path__ + "assets/img/one2.9057222d.png";